/** The seam that lets one shared UI drive Word/Excel/PowerPoint/Outlook. */

export type HostKind = 'word' | 'excel' | 'powerpoint' | 'outlook' | 'browser'

/** Composer scope toggle. `none` chats without any document/selection context. */
export type Scope = 'document' | 'selection' | 'none'

/** Format of content handed to the host for insertion. */
export type ContentFormat = 'text' | 'markdown' | 'html'

export interface SelectionInfo {
  text: string
  /** Rough paragraph count for the "Auswahl · n Absätze" badge. */
  paragraphs: number
  isEmpty: boolean
}

export interface ActiveDocumentRef {
  name: string
}

export interface HostAdapter {
  readonly host: HostKind
  /** Whether the host currently allows editing (Outlook read-mode → false). */
  readonly canEdit: boolean

  getSelection(): Promise<SelectionInfo>
  getDocumentText(): Promise<string>
  getContent(scope: Scope): Promise<string>

  replaceSelection(content: string, format?: ContentFormat): Promise<void>
  insertAtCursor(content: string, format?: ContentFormat): Promise<void>

  getActiveDocument(): Promise<ActiveDocumentRef | null>
}

/** Human-readable scope label, host-aware ("Ganze E-Mail", "Ganze Seite", …). */
export function scopeLabel(host: HostKind, scope: Scope): string {
  if (scope === 'selection') return 'Auswahl'
  if (scope === 'none') return 'Ohne Kontext'
  switch (host) {
    case 'outlook':
      return 'Ganze E-Mail'
    case 'browser':
      return 'Ganze Seite'
    default:
      return 'Ganzes Dokument'
  }
}
